import { configureStore } from '@reduxjs/toolkit';
import strategyReducer from './slices/strategySlice';
import chatReducer from './slices/chatSlice';

export const store = configureStore({
  reducer: {
    strategy: strategyReducer,
    chat: chatReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
